import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getTenantRuntime } from './tenant';

// Firebase configuration for hotel-support-chat project
const firebaseConfig = {
  apiKey: "AIzaSyBUhJR84mBsdOAe9-YzDKsA8ptIw9YvgWY",
  authDomain: "hotel-support-chat.firebaseapp.com",
  projectId: "hotel-support-chat",
  storageBucket: "hotel-support-chat.firebasestorage.app",
  messagingSenderId: "422230384703",
  appId: "1:422230384703:web:a501fa8782855767a6988a"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);

/** Platform reads are restricted to identity, memberships and master data. */
export function getPlatformDb() { return getFirestore(app); }
export function getTenantDb() { const runtime = getTenantRuntime(); return getFirestore(app, runtime.databaseId); }

// Initialize Analytics (only in production and if supported)
export const analytics = isSupported().then(yes => yes ? getAnalytics(app) : null);